export const convertToUTC = {
  methods: {
    convertToUTC(currentTime) {
      let currentDate

      // Check if currentTime is in the format "HH:MM"
      if (
        /^\d{2}:\d{2}$/.test(currentTime) ||
        /^\d{2}:\d{2}:\d{2}$/.test(currentTime)
      ) {
        const [hours, minutes] = currentTime.split(':').map(Number)
        const now = new Date()
        currentDate = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate(),
          hours,
          minutes,
          0
        )
      } else {
        // Parse the full date string
        currentDate = new Date(currentTime)
      }

      // Format the UTC date in HH:MM:SS format
      const utcHours = currentDate.getUTCHours().toString().padStart(2, '0')
      const utcMinutes = currentDate.getUTCMinutes().toString().padStart(2, '0')
      const utcSeconds = currentDate.getUTCSeconds().toString().padStart(2, '0')

      return `${utcHours}:${utcMinutes}:${utcSeconds}`
    },
  },
}
